import { baseUrl } from '../../../baseurl';
import { create } from 'zustand';
import axios from 'axios';

export const useAuth = create((set, get) => ({


    authCode: "",
    isAuthenticateByToken: "",
    errorMsg: false,
    authData: "",
    // isFollow: [],
    loader: false,
    isUserSubActive: false,
    districtsNum: 0,
    purchasedDistricts: [],
    isUnauthorized: false,
    packageIdRenewal: 0,
    userSubs: [],
    subscriptionMains: [],
    referringCode: "",
    hasSubOrNot: false,
    subscriptionsCount: 0,
    hasActiveSubscription: false,
    totalMonths : 0,
    usersData:{},
    actions: {
        sendToken: async (phoneNumber) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/Login/SendToken`, {
                "phoneNumber": phoneNumber
            })
                .then((res) => {
                    set((state) => ({ authCode: res.data }))
                    set((state) => ({ loader: false }))
                })
        },
        authenticateByToken: async (phoneNumber, token) => {
            await axios.post(`${baseUrl}/Login/AuthenticateByToken`, {
                "phoneNumber": phoneNumber,
                "token": token
            })
                .then((res) => {
                    if (res.data.token === null) {
                        set((state) => ({ errorMsg: true }))
                    } else {

                        localStorage.setItem("pelakToken", res.data.token)
                        // function parseJwt(token) {
                        var base64Url = res.data.token.split('.')[1];
                        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                        }).join(''));
                        set((state) => ({ authData: JSON.parse(jsonPayload) }))

                        localStorage.setItem("pelakAuthData", JSON.parse(jsonPayload).unique_name)

                        // window.location.replace('/invitaion');
                        // window.location.replace('/LoginLocation');
                        window.location.replace('/');

                        //    JSON.parse(jsonPayload);
                        // }
                    }
                })
        },

        // getAdsUserFollow: async (userId, adsMasterUserId) => {
        //     set((state) => ({ loader: true }))
        //     await axios.post(`${baseUrl}/User/GetAdsUserFollow`, {
        //         "userId": userId,
        //         "adsMasterUserId": adsMasterUserId
        //     })
        //         .then((res) => {
        //             if (res.data) {
        //                 set((state) => ({ isFollow: res.data }))
        //                 set((state) => ({ loader: false }))
        //             }
        //         })
        // },

        getUserInfoByToken: async (UserId) => {
            set((state) => ({ loader: true }))
            console.log();

            await axios.get(`${baseUrl}/User/UserInit?UserId=${UserId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })

                .then((res) => {
                    // console.log(res.data.referringCode  , "res.data.referringCode  in getUserInfoByToken");
                    // console.log(res.data  , "res.data.referringCode  in getUserInfoByToken 000000000000000000");
                    // console.log(res.data.subscriptionMains, "res.data.subscriptionMains in getUserInfoByToken");
                    // console.log(res.data.subscriptionMains?.length, "res.data.subscriptionMains in getUserInfoByToken ?.length");
                    // console.log(res.data.subscriptionMains[0], "res.data.subscriptionMains[0] in getUserInfoByToken");
                    // console.log(res.data.subscriptionMains[0]?.isActive, "res.data.subscriptionMains[0]?.isActive in getUserInfoByToken");
                    // console.log(res?.data?.subscriptionMains[0]?.tblUsrSubscriptionDetails[0].usrSubscriptionMainId, "res.data.subscriptionMains[0].tblUsrSubscriptionDetails in getUserInfoByToken 6767");

                    const x = res?.data?.subscriptionMains.reduce((acc, item) => {


                        if (Array.isArray(item.tblUsrSubscriptionDetails)) {
                            if (item?.isPaid) {
                                return acc.concat(item.tblUsrSubscriptionDetails);
                            }

                        }
                        return acc;
                    }, []);
                    set((state) => ({ purchasedDistricts: x }))
                    set((state) => ({ hasSubOrNot: res.data.subscriptionMains?.length }))
                    const userSubs = res?.data?.subscriptionMains.map((item) => {
                        if (Array.isArray(item.tblUsrSubscriptionDetails)) {
                            return item.tblUsrSubscriptionDetails; // Return each array as is
                        }
                        else {
                           

                        }
                    });
                    set((state) => ({ userSubs: userSubs }))
                    set((state) => ({ subscriptionMains: res.data.subscriptionMains }))

                    







                    set((state) => ({ isUserSubActive: res?.data?.subscriptionMains[0]?.isActive }))
                    set((state) => ({ districtsNum: res?.data?.subscriptionMains[0]?.tblUsrSubscriptionDetails?.length }))
                    // set((state) => ({ purchasedDistricts: res?.data?.subscriptionMains[0]?.tblUsrSubscriptionDetails }))
                    
                    // set((state) => ({ packageIdRenewal: res?.data?.subscriptionMains[0]?.tblUsrSubscriptionDetails[0].usrSubscriptionMainId }))
                    set((state) => ({ referringCode: res?.data?.referringCode }))
                    set((state) => ({ subscriptionsCount: res?.data?.subscriptionsCount }))
                    set((state) => ({ hasActiveSubscription: res?.data?.hasActiveSubscription }))
                    set((state) => ({ loader: false }))
                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        // Handle unauthorized error
                     
                        set((state) => ({ isUnauthorized: true }))
                    } else {
                        console.error("An error occurred:", error);
                    }
                });
        },
        // clearUserSubsCription : ()=>{
        //     set((state) => ({ purchasedDistricts: [] }))
        // }
        getusersData: async (UserId) => {
            await axios.get(`${baseUrl}/User/UserInit?UserId=${UserId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ usersData: res.data }))
                    
                }).catch(() => {
                   
                })
        },
    }

}))